<template>
  <div class="noprint">
    <b-card
      v-if="isLoaded"
      no-body
      border-variant="msstream"
    >
      <b-card-header
        header-bg-variant="msstream"
        header-text-variant="white"
        class="text-center"
      >
        <h6 class="m-0">
          <font-awesome-icon icon="shopping-cart"></font-awesome-icon
          >&nbsp;&nbsp;{{ $ml.get("consumptiontitle") }}
        </h6>
      </b-card-header>
      <b-card-body>
        <b-row class="justify-content-center mb-3">
          <h5>
            {{ $ml.get("pldatadelivered") }}
          </h5>
        </b-row>

        <b-row class="justify-content-center mb-4">
          <b-col style="text-align: right">
            {{ $ml.get("TBstarted") }} - {{defaultdisdate}}:
          </b-col>
          <b-col>
            <strong
              class="text-blue"
              >{{ formatNbr(Math.ceil(currentDataTB)) }} {{ $ml.get("TBunit") }} 
            </strong>
          </b-col>
        </b-row>

        <b-row v-if="$auth.getMyUser().roles.indexOf('admin') > -1" class="justify-content-center mb-3">
          <b-col style="text-align: right">
            {{ $ml.get("lastdatadelivered") }} - {{dateminus1}}:
          </b-col>
          <b-col>
            <strong
              class="text-blue"
              >{{ formatNbr(Math.ceil(lastDataTB)) }} {{ $ml.get("TBunit") }} 
            </strong>
          </b-col>
        </b-row>

        <b-row v-if="$auth.getMyUser().roles.indexOf('admin') > -1" class="justify-content-center mb-1">
          <b-button variant="msstreamblue" size="sm" @click="previousMonths(); showPreviousMonths = !showPreviousMonths">
            Previous months
            <b-icon v-if="!showPreviousMonths" icon="plus-circle" />
            <b-icon v-else icon="dash-circle" />
          </b-button>
        </b-row>
        
        <span v-if="showPreviousMonths">
          <span class="m-2" v-for="(value, index) in dataMonth" v-bind:key="index">
            <b-row class="justify-content-center mb-2">
              <b-col style="text-align: right">
                {{dateminus[index]}}: 
              </b-col>
              <b-col>
                <strong class="text-blue">
                  {{ formatNbr(Math.ceil(value)) }} {{ $ml.get("TBunit") }}
                </strong>
              </b-col>
            </b-row>
          </span>
        </span>


          <!--<b-col
            v-if="isAutoAdjust && !isContractSigned"
            md="4"
            sm="4"
            cols="12"
            style="text-align: center"
          >
            <a :href="($ml.current === 'FR') ? '/CGV_Quanteec_FR.pdf': 'https://quanteec.com/cgu/QUANTEEC_T+C_EN.pdf'" target="_blank">
              <b-row class="justify-content-center align-items-center">
                <b-col cols="3" style="padding-left: 0px; padding-right: 0px;">
                    <b-img
                    :src="require('@/assets/pdf.png')"
                    fluid
                    ></b-img>
                </b-col>
                <b-col cols="auto" style="padding-left: 0px; padding-right: 0px;">
                    {{$ml.get('termsofservice')}}
                </b-col>                      
              </b-row>
            </a>
          </b-col>-->
      </b-card-body>
    </b-card>

  </div>
</template>

<script>
import AnalyticsService from "@/services/analytics.service";
var analyticsService = new AnalyticsService();

const migrationTSDS = new Date(parseInt(process.env.VUE_APP_TSDS_MIGRATION_TIMESTAMP_MILLISECONDS) || 1740787200000);

var myDateBegin = new Date();
let moment = require("moment");

export default {
  name: "Consumption",
  data: function () {
    return {
      date : new Date(),
      defaultdisdate: moment(new Date(myDateBegin.getFullYear(), myDateBegin.getMonth(), myDateBegin.getDate(), 0, 0, 0)).format("MMM YYYY"),
      dateminus1: moment(new Date(myDateBegin.getFullYear(), myDateBegin.getMonth() - 1, myDateBegin.getDate(), 0, 0, 0)).format("MMM YYYY"),

      dateminus: [],
      showPreviousMonths : false,

      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      clientViewObject: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientViewObject() || this.$auth.getMyUser().client_infos[0]
          : this.$auth.getMyUser().client_infos[0],
      key: "",
      dateEnd: new Date(),
      dateBegin: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth(),
        1,
        0,
        0,
        0
      ),
      dateBeginLastMonth: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth() - 1,
        1,
        0,
        0,
        0
      ),
      dateEndLastMonth: new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth(),
        1,
        0,
        0,
        0
      ),

      interval: "1d",
      filter: "*",
      totalViewingTime: 0,
      totalViews: 0,

      TBnumber: '1',
      showEstimator: false,
      pricePerTB: '5',
      priceTotal: '5',
      estPrice: '1',
      currentPrice: 10,
      multiplierPrice: 10,
      partialMultiplierPrice: 10,
      basePrice: 10,
      basePrice2: 0,

      lastData: 0,
      lastDataTB: 0,
      lastDataX: 0,
      dataMonth: [],

      lastPrice: 0,

      currentData: 0,
      currentDataTB: 0,
      currentPricePerTB: 5,
      currentPriceTotal: 0,

      multiplierData: 1000,
      baseData: 1000,
      maxData: 0,
      priceData: 10,

      isAutoAdjust: true,
      paymentValue: 0,
      activatePayment: false,

      clientType: "plugin",
      isLoaded: false,
      forLater: false,

      isRIB: false,
      isContractReady: false,
      isContractSigned: false,
      typeOfContract: "views",
      cguAccepted: false,
      file: null,
      paymentdetails: false,
      showpreviousbilling: false,
      pdfListPriceEN: require('@/assets/QUANTEEC_Pricing_List_06_23.pdf'),
      pdfListPriceFR: require('@/assets/QUANTEEC_Listing_Prix_06_23.pdf'),
      
      billingitems: null,
    };
  },

  mounted() {
    this.key = this.clientView;
    this.loadData().then(() => {
      this.loadData_LastMonth();
    }).catch(err => {
      this.loadData_LastMonth();
    })
    
  },
  methods: {
    //Show modal if wrong date
    showModal(ref) {
      this.$refs[ref].show();
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    loadData() {
      let self = this;
      return new Promise((done, reject) => {
        let values = [{ name: "MB_peer", type: "sum" }];
        let options = {
          dateBegin: self.dateBegin,
          dateEnd: self.dateEnd,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            let totalMB_peer = self.MB_peer.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            self.totalData = totalMB_peer;
            self.currentData = Math.round(self.totalData / 1000000);
            self.currentDataTB = self.currentData / 1000;
            self.setAutoAdjust();

            cdnService
              .getCDNsData(self.$auth.token())
              .then((data) => {
                let dataCDN = data.bytes || 0;
                self.totalData = totalMB_peer + dataCDN / 1000;
                self.currentData = Math.round(self.totalData / 1000000);
                self.currentDataTB = self.currentData / 1000;
                self.setAutoAdjust();
                done();
              })
              .catch((err) => {
                self.totalData = totalMB_peer;
                self.currentData = Math.round(self.totalData / 1000000);
                self.currentDataTB = self.currentData / 1000;
                self.setAutoAdjust();
                done();
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loadData_LastMonth() {
      let self = this;
      return new Promise((done, reject) => {
        let values = [{ name: "MB_peer", type: "sum" }];
        let options = {
          dateBegin: self.dateBeginLastMonth,
          dateEnd: self.dateEndLastMonth,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            let totalMB_peer = self.MB_peer.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            self.lastData = Math.round(totalMB_peer/ 1000000);
            self.lastDataTB = self.lastData / 1000;
            self.isLoaded = true;
            

          })
          .catch((err) => {
            console.error(err);
            self.isLoaded = true;
            reject(err);
          });
      });
    },

    previousMonths() {
      this.dataMonth = [];
      for (let i = 0; i < 10; i++) {
        let idx = i;
        this.dateminus[i] = moment(new Date(myDateBegin.getFullYear(), myDateBegin.getMonth() - (i + 2), myDateBegin.getDate(), 0, 0, 0)).format("MMM YYYY");
        this.dataMonth.push(0);
        this.loadData_MonthX(idx + 1).then(lastDataTBX => {
          this.dataMonth[idx] = lastDataTBX;
          this.dataMonth = this.dataMonth.slice();
        })
        .catch(err => {
          console.log("err PreviousMonths");
        });
      }
    },

    loadData_MonthX(monthNbr) {
      let self = this;
      let dateBeginLastMonthX = new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth() - monthNbr - 1,
        1,
        0,
        0,
        0
      );
      let dateEndLastMonthX = new Date(
        myDateBegin.getFullYear(),
        myDateBegin.getMonth() - monthNbr,
        1,
        0,
        0,
        0
      );
      return new Promise((done, reject) => {
        let values = [{ name: "MB_peer", type: "sum" }];
        let options = {
          dateBegin: dateBeginLastMonthX,
          dateEnd: dateEndLastMonthX,
          interval: self.interval,
          filter: self.filter,
        };
        let data = self.templateRequest(options, values);
        self
          .loadRequest(data, values)
          .then(() => {
            let totalMB_peer = self.MB_peer.reduce((a, b) => {
              return { y: Math.round(a.y + b.y) };
            }).y;
            let lastDataX = Math.round(totalMB_peer/ 1000000);
            let lastDataTBX = lastDataX / 1000;
            self.isLoaded = true;
            done(lastDataTBX);
          })
          .catch((err) => {
            console.error(err);
            self.isLoaded = true;
            reject(err);
          });
      });
    },

    loadRequest(data, valuesToFill) {
      let self = this;
      let query = data;
      return new Promise((done, reject) => {
        if (new Date(self.dateBeginLastMonth) > migrationTSDS) {
          query.query.bool.filter.push({
            term: {
              client: self.key,
            },
          });
          self.key = "tsds_metrics";
        }
        analyticsService
          .getAnalyticsFromServer(self.key, query, self.$auth.token())
          .then((response) => {
            let buckets = response.aggregations.histogram.buckets;
            for (let j = 0; j < valuesToFill.length; j++) {
              let myValue =
                valuesToFill[j].name.indexOf("keyword") > -1
                  ? valuesToFill[j].name.split(".")[0]
                  : valuesToFill[j].name;
              self[myValue] = [];
            }
            for (let i = 0; i < buckets.length; i++) {
              for (let j = 0; j < valuesToFill.length; j++) {
                let myValue =
                  valuesToFill[j].name.indexOf("keyword") > -1
                    ? valuesToFill[j].name.split(".")[0]
                    : valuesToFill[j].name;
                self[myValue].push({
                  x: new Date(buckets[i].key),
                  y: buckets[i][myValue].value,
                });
              }
            }
            done();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    templateRequest({ dateBegin, dateEnd, interval, filter }, values) {
      let data = {
        query: {
          bool: {
            filter: [
              {
                range: {
                  timestamp: {
                    gte: dateBegin.getTime().toString(),
                    lte: dateEnd.getTime().toString(),
                    format: "epoch_millis",
                  },
                },
              },
              {
                query_string: {
                  analyze_wildcard: true,
                  query: filter,
                },
              },
            ],
          },
        },
        size: 0,
        aggs: {
          histogram: {
            date_histogram: {
              fixed_interval: interval,
              field: "timestamp",
              min_doc_count: 0,
              extended_bounds: {
                min: dateBegin.getTime().toString(),
                max: dateEnd.getTime().toString(),
              },
              format: "epoch_millis",
            },
            aggs: {},
          },
        },
      };

      for (var i = 0; i < values.length; i++) {
        let name =
          values[i].name.indexOf("keyword") > -1
            ? values[i].name.split(".")[0]
            : values[i].name;
        let value = values[i].name;
        let type = values[i].type;
        data.aggs.histogram.aggs[name] = {};
        data.aggs.histogram.aggs[name][type] = {
          field: value,
        };
      }

      return data;
    },
    formatNbr(value)
    {
        if (value >= 1000 && (this.$ml.current === 'EN')) 
          value = new Intl.NumberFormat('en-EN').format(value); 
        else if (value > 1000 && (this.$ml.current === 'FR'))
          value = new Intl.NumberFormat('fr-FR').format(value);
        else if (value === 0.5) value = "< 1";

        return value;
    },

  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none;
  }
}

input:invalid {
    border: 3px solid red;
}

datalist {
  display: flex;
  justify-content: space-between;
  width: 300px;
  font-size: 10px;
}

option {
  padding: 0;
}

input[type="range"] {
  width: 300px;
  margin: 0;
}
</style>